import { render, staticRenderFns } from "./RequestTypeSelectorDialog.vue?vue&type=template&id=28e1f54e&lang=pug"
import script from "./RequestTypeSelectorDialog.vue?vue&type=script&lang=js"
export * from "./RequestTypeSelectorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports